import CarrierForm from "kinnect-front/Warehouse/Carriers/CarrierForm";
import { Carrier } from "kinnect-models";
import { KListTile, KSelect } from "kinnect-general";
import { VDialog, VIcon } from "vuetify/lib";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "CarrierField",

	extends: KSelect,

	props: {
		chips: {
			default: true,
			type: Boolean
		},
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		persistentHint: {
			default: true,
			type: Boolean
		},
		prependIcon: {
			default: "local_shipping",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	computed: {
		sortedItems() {
			return sortByKey( this.items, this.itemText );
		}
	},

	methods: {
		createCarrier( { data: carrier } ) {
			this.$emit( "create", new Carrier( carrier ) );
		}
	},

	render() {
		return <KSelect
			attrs={{
				...this.$props,
				items: this.sortedItems
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <CarrierForm
					formTitle="Add a Carrier"
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createCarrier}
				></CarrierForm>}
			</VDialog>}

			<KListTile text="No carriers to display" slot="no-data"></KListTile>
		</KSelect>;
	}
};
